// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6925 ? "2c386607" : chunkId) + "." + {"2741":"653c787f2490dc24","6925":"ce0f993d0a2318e3","9523":"4cc7e532491a12bf","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};